import { useState, useMemo, useEffect } from 'react'

const usePagination = <T,>(items: T[], itemsPerPage: number = 1, filteredItem?: T | null) => {
  const [currentPage, setCurrentPage] = useState<number>(1)

  const totalPages: number = useMemo(() => {
    if (filteredItem) {
      return 1
    } 
    return Math.ceil(items.length / itemsPerPage)
  }, [items, itemsPerPage, filteredItem])

  const currentItems = useMemo(() => {
    if (filteredItem){
      return [filteredItem]
    }
    const start = (currentPage - 1) * itemsPerPage
    return items.slice(start, start + itemsPerPage)
  }, [items, currentPage, itemsPerPage, filteredItem])

  useEffect(() => {
    if (filteredItem) {
      setCurrentPage(1)
    }
  }, [filteredItem])

  const goToPage = (page: number) => {
    if (!filteredItem && page >= 1 && page <= totalPages) {
      setCurrentPage(page)
    }
  }

  return {
    currentItems,
    currentPage,
    totalPages,
    goToPage,
    nextPage: () => goToPage(currentPage + 1),
    prevPage: () => goToPage(currentPage - 1),
  }
}

export default usePagination